import { userService } from './userService'
import { openInactiveUserModal } from '../reducers/uiSlice'

class UserActivityService {
  constructor() {
    this.store = null
    this.lastCheck = 0
    this.isActive = true
    this.checkInterval = 30 * 1000
  }

  setStore(store) {
    this.store = store
  }

  checkUserActivity(force = false) {
    if (!navigator.onLine) return Promise.resolve(true)

    const now = Date.now()
    if (!force && now - this.lastCheck < this.checkInterval) {
      if (!this.isActive && this.store) {
        this.store.dispatch(openInactiveUserModal())
      }
      return Promise.resolve(this.isActive)
    }

    return userService.getAccountDetails()
      .then(response => {
        const userData = response.data.data || response.data
        this.lastCheck = now

        if (userData && userData.is_active === false) {
          this.isActive = false
          if (this.store) {
            this.store.dispatch(openInactiveUserModal())
          }
          return false
        }
        
        this.isActive = true
        return true
      })
      .catch(() => {
        this.isActive = true
        return true
      })
  }
}

export const userActivityService = new UserActivityService()